import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

const QueryParamsSection = ({ autoQueryParams, setAutoQueryParams, parsedQueryParamsList, queryParams, setQueryParams }) => (
  <div>
    <FormControlLabel
      control={
        <Switch
          id="autoQueryParams"
          checked={autoQueryParams}
          onChange={(e) => setAutoQueryParams(e.target.checked)}
          inputProps={{ "aria-label": "Let AI manage query parameters" }}
        />
      }
      label={<span className="muted">Let AI manage query parameters</span>}
      sx={{ m: 0, mb: 1 }}
    />
    {autoQueryParams && parsedQueryParamsList.length > 0 && (
      <div className="muted" style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <p style={{ margin: 0 }}>AI suggested parameters:</p>
        <ul style={{ margin: "0 0 0 16px", padding: 0, listStyle: "disc", color: "inherit" }}>
          {parsedQueryParamsList.map((param, idx) => (
            <li key={`${param.name || "param"}-${idx}`}>
              <strong>{param.name || "(unnamed)"}</strong>
              {param.type ? ` (${param.type})` : ""}
              {param.required ? " - required" : ""}
              {param.description ? `: ${param.description}` : ""}
            </li>
          ))}
        </ul>
      </div>
    )}
    {!autoQueryParams && (
      <textarea
        value={queryParams}
        onChange={(e) => setQueryParams(e.target.value)}
        rows={3}
        className="code-block"
        placeholder='e.g., [ { "name": "userId", "type": "string", "required": true, "description": "User id" } ]'
      />
    )}
  </div>
);

export default QueryParamsSection;
